module.exports = __webpack_public_path__ + "img/signin-logo.6b0caa1c.svg";